import { HashRouter, Routes, Route, Link } from "react-router-dom";
import Home from "./Component/Home/Home";
import About from "./Component/About/About";
import Contact from "./Component/Contact/Contact";
import Portfolio from "./Component/Portfolio/Portfolio";
import Classes from "./Component/Classes/Classes";
import { CiLocationOn } from "react-icons/ci";
import { IoPhonePortraitOutline } from "react-icons/io5";
import { FaPhone } from "react-icons/fa6";
import { SiMinutemailer } from "react-icons/si";
import './index.css';


function App() {
    return (
        <HashRouter>
            <div>
                <nav className="navbar navbar-expand-lg bg-body-tertiary">
                    <div className="container-fluid">                     
                        <div className="collapse navbar-collapse text-end" id="navbarNavAltMarkup">
                            <div className="navbar-nav text-end">
                                <Link className="nav-link">
                                    Address: junction road, Bangalore
                                </Link>
                                <Link className="nav-link">
                                    Phone: +91 92753 76357
                                </Link>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>

            <div className="">
                <nav className="navbar navbar-expand-lg">
                    <div className="container">
                        <Link className="navbar-brand" to={"/"}>
                            <img src="./PICS/logo1.png" width={200}className="img-fluid" />
                        </Link>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                                <li className="nav-item me-3">
                                    <Link className="nav-link active" aria-current="page" to={"/"}>Home</Link>
                                </li>
                                <li className="nav-item me-3">
                                    <Link className="nav-link" to={'/about'}>About</Link>
                                </li>
                                <li className="nav-item dropdown me-3">
                                    <Link className="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        Blog
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li><Link className="dropdown-item" >Action</Link></li>
                                        <li><Link className="dropdown-item" >Another action</Link></li>
                                        <li><hr className="dropdown-divider"/></li>
                                        <li><Link className="dropdown-item" >Something else here</Link></li>
                                    </ul>
                                </li>
                                {/* <li className="nav-item me-3">
                                    <Link className="nav-link">Shop</Link>
                                </li> */}
                                <li className="nav-item me-3">
                                    <Link className="nav-link" to={"/portfolio"}>Portfolio</Link>
                                </li>
                                <li className="nav-item me-3">
                                    <Link className="nav-link" to={"/classes"}>Classes</Link>
                                </li>
                                <li className="nav-item me-3">
                                    <button type="button" class="nav-link btn" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                        Contact Us
                                    </button>
                                    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                        <div class="modal-dialog modal-xl">
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <h5 class="modal-title" id="exampleModalLabel">Contact Us</h5>
                                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                </div>
                                                <div class="modal-body">
                                                    <div className="container">
                                                        <div className="row mt-5 mb-5">
                                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                                <h1 className="contact-heading mb-4">Enquiry</h1>
                                                                <div className="pt-4 ps-5 text-center">
                                                                    <p><CiLocationOn className="me-2" />Junction road, Bangalore</p>
                                                                    <p><SiMinutemailer className="me-2" />Email: Demo@Example.co</p>
                                                                    <p><FaPhone className="me-2" />Call: +91 34564 54457</p>
                                                                    <p><IoPhonePortraitOutline className="me-2" />Phone: +91 65432 87856</p>
                                                                </div>
                                                                <div>
                                                                    <iframe width="100%" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=1%20Grafton%20Street,%20Dublin,%20Ireland+(My%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
                                                                        <a href="https://www.gps.ie/">gps systems</a>
                                                                    </iframe>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                                <div className="p-4" style={{marginTop: 100}}>
                                                                    <label>Name</label>
                                                                    <input type="text" className="form-control" />
                                                                    <label>Email</label>
                                                                    <input type="text" className="form-control" />
                                                                    <label>Mobile no.</label>
                                                                    <input type="text" className="form-control" />
                                                                    <label>Message</label>
                                                                    <textarea className="form-control" rows={3}></textarea>
                                                                    <button type="submit" className="btn submit-contact">Submit</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>`
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>

            <Routes>
                <Route path="/" element={<Home />}></Route>
                <Route path="/about" element={<About />}></Route>
                <Route path="/contact" element={<Contact />}></Route>
                <Route path="/portfolio" element={<Portfolio />}></Route>
                <Route path="/classes" element={<Classes />}></Route>
            </Routes>

            <div className="" id="footer-img">
                <footer className="text-center text-lg-start">
                    <div className="container p-4 pb-0">
                        <section className="mt-5">
                            <div className="row">
                            <div className="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3">
                                <h6 className="text-uppercase mb-4 font-weight-bold">
                                    Company name
                                </h6>
                                <p>
                                    Here you can use rows and columns to organize your footer
                                    content. Lorem ipsum dolor sit amet, consectetur adipisicing
                                    elit.
                                </p>
                                <p>
                                    Here you can use rows and columns to organize your footer
                                    content. Lorem ipsum dolor sit amet, consectetur adipisicing
                                    elit.
                                </p>
                            </div>
                            <hr className="w-100 clearfix d-md-none" />
                            <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
                                <h6 className="text-uppercase mb-4 font-weight-bold">Products</h6>
                                <p>
                                    <a className="text-decoration-none text-dark">Art work</a>
                                </p>
                                <p>
                                    <a className="text-decoration-none text-dark">Letter picking</a>
                                </p>
                                <p>
                                    <a className="text-decoration-none text-dark">Letter reading</a>
                                </p>
                                <p>
                                    <a className="text-decoration-none text-dark">Rhyems</a>
                                </p>
                            </div>
                            <hr className="w-100 clearfix d-md-none" />
                            <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3">
                                <h6 className="text-uppercase mb-4 font-weight-bold">
                                Useful links
                                </h6>
                                <p>
                                    <a className="text-decoration-none text-dark">Art work</a>
                                </p>
                                <p>
                                    <a className="text-decoration-none text-dark">Letter picking</a>
                                </p>
                                <p>
                                    <a className="text-decoration-none text-dark">Letter reading</a>
                                </p>
                                <p>
                                    <a className="text-decoration-none text-dark">Rhyems</a>
                                </p>
                            </div>
                            <hr className="w-100 clearfix d-md-none" />
                            <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
                                <h6 className="text-uppercase mb-4 font-weight-bold">Contact</h6>
                                <p><i className="fas fa-home mr-3"></i> New York, NY 10012, US</p>
                                <p><i className="fas fa-envelope mr-3"></i> info@gmail.com</p>
                                <p><i className="fas fa-phone mr-3"></i> + 01 234 567 88</p>
                                <p><i className="fas fa-print mr-3"></i> + 01 234 567 89</p>
                            </div>
                            </div>
                        </section>
                        <hr className="" />
                        <section className="p-3 pt-0">
                            <div className="row d-flex align-items-center">
                                <div className="col-md-7 col-lg-8 text-center text-md-start">
                                    <div className="p-3">
                                    © 2024 Copyright:
                                    </div>
                                </div>
                                <div className="col-md-5 col-lg-4 ml-lg-0 text-center text-md-end">
                                    kids Play school
                                </div>
                            </div>
                        </section>
                    </div>
                </footer>
            </div>
            
        </HashRouter>
    );
}

export default App;
